import { SnapSSOAPIClient, type SnapSSOAPIClientConfig } from "@snapchat/sso-auth";

export class SnapSSOAPIClientWithPreRedirect extends SnapSSOAPIClient {
    private readonly preRedirect?: () => void;

    constructor(config: SnapSSOAPIClientConfig, preRedirect?: () => void) {
        super(config);
        this.preRedirect = preRedirect;
    }

    override redirectToAccountsServer(referrer = ""): void {
        if (this.preRedirect) {
            this.preRedirect();
        }

        super.redirectToAccountsServer(referrer);
    }
}
